import React from 'react';
import { Route, Routes } from 'react-router-dom';
import About from '../screens/About';
import EarlyAccessProgram from '../screens/EarlyAccessProgram';
import ForgotPassword from '../screens/ForgotPassword';
import HomePageNew from '../screens/HomePageNew';
import NotFound from '../screens/NotFound';
import Pricing from '../screens/Pricing';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import Product from '../screens/Product';
import ServerError from '../screens/ServerError';
import SignIn from '../screens/SignIn';
import TermsOfUse from '../screens/TermsOfUse';

/**
 * Application routes component that defines all route mappings
 *
 * This component centralizes all routing logic and provides:
 * - Clean separation of routing from app-level concerns
 * - Easy maintenance and modification of routes
 * - Components are self-contained with their own layouts
 * - Single source of truth for all application routes
 *
 * EllaFin Minimum Launch Pages:
 * - Homepage - Hero with value prop, CTAs for Early Access
 * - Product - Features, how it works, platform overview
 * - Pricing - Simple contact placeholder
 * - About - Mission, credibility
 * - Contact - Sales inquiry, support
 * - Early Access - Lead capture
 * - Login - Customer login placeholder
 * - Privacy Policy - Legal requirement
 * - Terms of Service - Legal requirement
 *
 * @returns {React.ReactElement} The application routes configuration
 */
function AppRoutes() {
  return (
    <Routes>
      {/* Homepage - Redesigned */}
      <Route path="/" element={<HomePageNew />} />

      {/* Main pages */}
      <Route path="/product" element={<Product />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/about" element={<About />} />

      {/* Lead capture / signup */}
      <Route path="/early-access" element={<EarlyAccessProgram />} />

      {/* Authentication */}
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/login" element={<SignIn />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Legal pages */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfUse />} />

      {/* Error pages */}
      <Route path="/server-error" element={<ServerError />} />

      {/* 404 - catch all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
